import {getUserData} from "./Utils"
import {DefaultRoute, DefaultRouteAdmin, DefaultRouteNotAuth} from "../router/routes"

export const getHomeRoute = () => {
    const user = getUserData()
    if (user && user.role === 'client') {
        return DefaultRoute
    } else if (user && user.role === 'admin') {
        return DefaultRouteAdmin
    } else {
        return DefaultRouteNotAuth
    }
}